import React, { useState, useEffect } from "react";
import styled from "styled-components";

// import Page from "components/Page";
import SearchBar from "./SearchBar";
import RowCard from "./RowCard";

import { useSelector, useDispatch, shallowEqual } from "react-redux";
import {
  SG_GET_ACTIVITY_LOGS,
  UPDATE_ACTIVITY_LOG_PAGE_NUMBER,
} from "constants/actions";

import { Dimmer, Loader, Card, Pagination, Segment } from "semantic-ui-react";


const List = () => {
  // employee_record_value
  const dispatch = useDispatch();

//   const [resetPageLoad, setResetPageLoad] = useState(false);
const [searchTerm, setSearchTerm] = useState("");

  const [results, setResults] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    // if the response is ok 200
    dispatch({
      type: SG_GET_ACTIVITY_LOGS,
      payload: `page=${page}${searchTerm ? `&search=${searchTerm}` : ""}`,
    });

    setLoading(true);
  }, [dispatch, page, searchTerm]);

  const { get_activity_log } = useSelector(
    (state) => ({
      get_activity_log: state.activity_log,
    }),
    shallowEqual
  );


  useEffect(() => {
    setResults(get_activity_log?.activity_log?.results);
    setPage(get_activity_log?.pageNumber);
    setTotalPages(
      Math.ceil(
        get_activity_log?.activity_log?.count /
          get_activity_log?.activity_log?.page_size
      )
    );
  }, [get_activity_log, page]);

  function handlePageChange(event, value) {
    setPage(value.activePage);
    dispatch({
      type: UPDATE_ACTIVITY_LOG_PAGE_NUMBER,
      payload: value.activePage,
    });
  }



  useEffect(() => {
    const timer1 = setTimeout(() => {
      setLoading(get_activity_log?.pending);
    }, 2000);
    return () => clearTimeout(timer1);
  }, [get_activity_log]);

  return (
    <Container>
        <SectionDiv>
                <SearchBar
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm} /> 

            </SectionDiv>
 

      <Segment id="results" basic>
        <Dimmer active={loading}>
          <Loader />
        </Dimmer>
        <Card.Group>
          {results && <RowCard rows={results} />}
        </Card.Group>
      </Segment>
      <SectionDiv>
        <Pagination
          ellipsisItem={null}
          firstItem={null}
          lastItem={null}
          activePage={page}
          totalPages={totalPages || 0}
          onPageChange={handlePageChange}
        />
      </SectionDiv>
    </Container>
  );
};

export default List;

const Container = styled.div`
  //   min-height: 90vh;
  padding: 30px;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

const SectionDiv = styled.div`
  padding: 30px 15px;
`;
